import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'amfe-flexible'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.prototype.$http = axios
Vue.config.productionTip = false
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Vant from 'vant'
import 'vant/lib/index.css'
// import './styles/mobile.less'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
Vue.config.productionTip = false

// 获取 屏幕的宽度
// 判断屏幕宽度是 PC 还是 移动
// 手动获取 html 跟标签
// 指定他的 font-size

Vue.use(VueQuillEditor)
Vue.use(Vant)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
//字符串截选
Vue.filter("ellipsis", function (value, number) {
  if (!value) return "";
  if (value.length > number) {
    return value.slice(0, number) + "...";
  }
  return value;
});
//跳转
Vue.prototype.goNext = function (val) {
  router.push(val);
};